import CloseIconButton from "./CloseIconButton";

const DialogCloseButton = ({ onClick }: { onClick: () => void }) => (
  <CloseIconButton color="secondary" onClick={onClick} sx={{ position: "absolute", right: 12, top: 12 }} />
);

export default DialogCloseButton;
